import { slice } from './slice'

const worklistActions = {
	...slice.actions,
}

export default worklistActions
